import { useState, useEffect } from 'react'
import axios from 'axios'

export const useAddressApi = initialAddress => {
    const [addressSearchString, setAddressSearchString] = useState('')
    const [isLoadingAddress, setIsLoadingAddress] = useState(false)
    const [isAddressSearchError, setIsAddressSearchError] = useState(false)
    const [foundAddresses, setFoundAddresses] = useState([])

    const clearSearchString = () => {
        setAddressSearchString('')
    }

    useEffect(() => {
        setIsAddressSearchError(false)

        if (addressSearchString === '') {
            setFoundAddresses([])
            return
        }

        setIsLoadingAddress(true)
        axios
            .get(`${process.env.API_URL}/locations/address-autocomplete`, {
                params: {
                    search: addressSearchString
                }
            })
            .then(response => {
                const suggestions = response.data.predictions.map(p => {
                    return p.description
                })
                console.log({ suggestions })
                setFoundAddresses(suggestions)
                setIsLoadingAddress(false)
            })
            .catch(e => {
                setIsLoadingAddress(false)
                setIsAddressSearchError(true)
            })
    }, [addressSearchString])

    return {
        isLoadingAddress,
        addressSearchString,
        setAddressSearchString,
        isAddressSearchError,
        foundAddresses,
        clearSearchString
    }
}
